import './theme/vue.scss'
import {create} from './demo-block/plugin'
import * as Components from '../src/components/index.js'
import Alert from '../src/components/Alert';
const Vue = window.Vue
import LightBootstrapDashboard from '../src/light-bootstrap-main'
import PropsTable from './components/props-table';
import Chartist from '../node_modules/chartist'
import {Select, Option, Tag, Slider, DatePicker, TimePicker, Progress} from '../node_modules/element-ui'
import '../node_modules/element-ui/packages/theme-chalk/src/index.scss'
import * as VueGoogleMaps from 'vue2-google-maps'
import FormWizard from '../node_modules/vue-form-wizard'
import '../node_modules/vue-form-wizard/dist/vue-form-wizard.min.css'
import swal from '../node_modules/sweetalert2'
import '../node_modules/sweetalert2/dist/sweetalert2.css'
import '../public/static/css/nucleo_icons.css'

window.swal = swal
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAamVCoyQ4AuvBpxVRMs9P-HFkfPVQj0Kw'
  }
})

Vue.use(LightBootstrapDashboard)

Vue.use(Select)
Vue.use(Option)
Vue.use(Tag)
Vue.use(Slider)
Vue.use(DatePicker)
Vue.use(Progress)
Vue.use(TimePicker)
Vue.use(FormWizard)
Vue.component(PropsTable.name, PropsTable);
Vue.component(Alert.name, Alert);
window.Chartist = Chartist

for (let key in Components) {
  const toRegister = Components[key]
  if (toRegister.install) {
    Vue.use(toRegister)
  } else {
    if (toRegister.name) {
      Vue.component(toRegister.name, toRegister)
    }
  }
}
window.DemoBoxVue = {
  create
}



// WEBPACK FOOTER //
// ./index.js